"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Invoice_PriceComponent = exports.Invoice_PriceComponentTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_Money_1 = require("./RTTI_Money");
var Invoice_PriceComponentTypeKind;
(function (Invoice_PriceComponentTypeKind) {
    Invoice_PriceComponentTypeKind["_base"] = "base";
    Invoice_PriceComponentTypeKind["_surcharge"] = "surcharge";
    Invoice_PriceComponentTypeKind["_deduction"] = "deduction";
    Invoice_PriceComponentTypeKind["_discount"] = "discount";
    Invoice_PriceComponentTypeKind["_tax"] = "tax";
    Invoice_PriceComponentTypeKind["_informational"] = "informational";
})(Invoice_PriceComponentTypeKind = exports.Invoice_PriceComponentTypeKind || (exports.Invoice_PriceComponentTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Invoice_PriceComponent = t.recursion('IInvoice_PriceComponent', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(Invoice_PriceComponentTypeKind, 'Invoice_PriceComponentTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        factor: RTTI_decimal_1.RTTI_decimal,
        _factor: RTTI_Element_1.RTTI_Element,
        amount: RTTI_Money_1.RTTI_Money
    });
});
//# sourceMappingURL=RTTI_Invoice_PriceComponent.js.map